import React, { useState } from "react";
import "./Dashboard.css";

function Dashboard() {
  const [isFlashing, setIsFlashing] = useState(false);

  const handleClick = () => {
    setIsFlashing(true);

    // Wait 4 seconds before redirecting to call Greenview San Diego Hardscape
    setTimeout(() => {
      window.location.href = "tel:+16194649153";
    }, 4000);
  };

  return (
    <div className="dashboard-container">
      <div className="login-container animate-in">
        <img
          src="/seal.png"
          alt="Greenview San Diego Hardscape Seal"
          className="seal"
        />

        <h1 className="dashboard-title">
          Greenview San Diego Hardscape
        </h1>

        <h2 className="dashboard-subtitle">
          Licensed C-27 Landscape Contractor Portal — CSLB #1141945
        </h2>

        <form className="login-form">
          <div className="form-group">
            <label htmlFor="email">
              Work Email (Staff / Contractor)
            </label>
            <input
              type="email"
              id="email"
              placeholder="Enter your work email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              Portal Password
            </label>
            <input
              type="password"
              id="password"
              placeholder="Enter your password"
              required
            />
          </div>

          <button type="submit" className="login-button">
            Access Contractor Portal
          </button>
        </form>

        <div className="forgot-password">
          <a href="/forgot-password">
            Need Help Logging In?
          </a>
        </div>
      </div>

      {/* Quick Call Button – Connects directly to contractor */}
      <button
        className={`robot-btn ${isFlashing ? "flashing" : ""}`}
        onClick={handleClick}
        aria-label="Call Greenview San Diego Hardscape"
      >
        📞
      </button>
    </div>
  );
}

export default Dashboard;